import { useState } from "react";
import "./Navbar.css";
import logo from "../../../assets/img/branding/Logos/equ-logo-blu.webp";
import NavigationLinkContainer from "./NavigationLinkContainer";
import PrimaryAnchorBtn from "../Anchors/PrimaryAnchorBtn";
import { Twirl as Hamburger } from 'hamburger-react';

const NAVIGATION_LINKS = [
 {
  title: "Services",
  path: "/#services"
 },
 {
  title: "Partners",
  path: "/#partners"
 },
 {
  title: "Pricing",
  path: "/#contact"
 },
 {
  title: "Roadmap",
  path: "/Roadmap"
 },
 {
  title: "Features",
  path: "/Features"
 },
 {
  title: "Industries",
  path: "/Industries",
  subLinks: [
   { title: "Equipment", path: "/Industries/Equipment" },
   { title: "Tools", path: "/Industries/Tools" },
   { title: "Rope Access", path: "/Industries/RopeAccess" },
   { title: "Plant Hire", path: "/Industries/PlantHire" },
  ],
    }
 /*,{
  title: "Blog",
  path: "/blog",
  external: true,
  newTab: false
 }*/
];

export default function Navbar() {
 const [mobileNavVisible, setMobileNavVisiblity] = useState(false);

 return (
  <nav className="bg-light fixed-top d-flex">
   <a href="/" className="d-flex align-items-center">
    <img className="navbar-brand logo" src={logo} alt="equi-track logo" /></a>
   <div className="d-none d-lg-flex ms-3">
    <NavigationLinkContainer NAVIGATION_LINKS={NAVIGATION_LINKS} />
   </div>

   <div className="d-none d-lg-flex">
    <PrimaryAnchorBtn title="Free Demo & Quote" path="/#contact" icon="ai-globe" />
   </div>
   <div className="d-flex d-lg-none ms-auto">
    <Hamburger toggled={mobileNavVisible} toggle={setMobileNavVisiblity} direction="left" />

    {
     mobileNavVisible &&
     <div id="mobileNav" className="bg-light">
      <ul className="navbar-nav py-1">
       <NavigationLinkContainer NAVIGATION_LINKS={NAVIGATION_LINKS} mobileNavbar={true} closeNavbar={() => setMobileNavVisiblity(false)} />
       <PrimaryAnchorBtn title="Free Demo & Quote" path="/#contact" className="my-2" onClick={() => setMobileNavVisiblity(false)} />
      </ul>
     </div>
    }
   </div>
  </nav>
 )
}
